export const REPORT_TYPES = {
  DISPLAYABLE: [
    "pdf",
    "jpeg",
    "html",
    "jpg",
    "png",
    "gif",
    "tif",
    "tiff",
    "svg",
  ],
  TABULAR: ["csv", "tsv"],
  MARKDOWN: ["md", "markdown"],
  // Any other output tagged "text" in the pipeline is shown as text too.
  TEXT: ["txt", "log", "out", "err"],
  RUNNABLE: ["app"],
};

export const MAXIMUM_REPORT_FILE_SIZE = 209715200; //200MB

// Files at or above this size are not fully parsed into a table — the browser
// would block for tens of seconds. A byte-prefix preview is shown instead.
// Distinct from MAXIMUM_REPORT_FILE_SIZE, which governs pdf/html/image display.
export const MAXIMUM_TABULAR_FILE_SIZE = 26214400; // 25MB

// A parsed table holds every cell as a JS string inside a row object, which
// takes several times the file's size in browser memory. These bound the
// estimate shown before a full load.
export const TABULAR_MEMORY_FACTOR_LOW = 5;
export const TABULAR_MEMORY_FACTOR_HIGH = 10;

// Byte prefix requested for the preview.
export const TABULAR_PREVIEW_BYTES = 2097152; // 2MB

// Rows shown from that prefix.
export const TABULAR_PREVIEW_ROWS = 1000;

// Byte prefix shown for text and markdown reports. Larger files show this
// prefix with a notice, so they never fall through to download only.
export const TEXT_PREVIEW_BYTES = 2097152; // 2MB
